import { getHostLocation } from './hostLocation';

/**
 * @deprecated use getCloudAwareOrigin from 'owa-account-cloud' instead.
 */
export function getOrigin(): string {
    const hostLocation = getHostLocation();
    let origin = hostLocation.origin;

    if (!origin) {
        // Some older versions of IE11 have a bug where location.origin is not populated. So, manually fix it up here.
        origin =
            hostLocation.protocol +
            '//' +
            hostLocation.hostname +
            (hostLocation.port ? ':' + hostLocation.port : '');
    }

    return origin;
}

/**
 * @deprecated use getCloudAwareOriginWithTrailingSlash from 'owa-account-cloud' instead.
 */
export function getOriginWithTrailingSlash(): string {
    return getOrigin() + '/';
}
